'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (str) {
  var chars = ('' + str).split(' ').map(function (word) {
    return word.charAt(0);
  });
  return chars.length > 1 ? '' + chars[0] + chars[chars.length - 1] : chars[0];
};